export { default } from './Table';



// WEBPACK FOOTER //
// ./src/design-system/atoms/Table/index.jsx